import axios from 'axios';

export default async function prospectPut(prospectInfo, _appStatus) {
  try {
    return await axios.put(`${process.env.REACT_APP_API_URL}/prospect`, {
      application_id: prospectInfo.application_id || null,
      first_name: prospectInfo.first_name,
      last_name: prospectInfo.last_name,
      email: prospectInfo.email,
      phone: prospectInfo.phone,
      second_contact_first_name: prospectInfo.second_contact_first_name ?? '',
      second_contact_last_name: prospectInfo.second_contact_last_name ?? '',
      second_contact_email: prospectInfo.second_contact_email ?? '',
      second_contact_phone: prospectInfo.second_contact_phone ?? '',
      loan_officer_id: prospectInfo.loan_officer_id,
      application_data: prospectInfo.application_data,
    });
  } catch (error) {
    console.error(error);
    return error.response;
  }
}
